import { theme } from 'theme';
import { Skeleton } from '@mui/material';

export const MemberZoneStatusSkeleton = () => {
  return (
    <>
      <Skeleton
        id={'status-skeleton'}
        data-testid={'status-skeleton'}
        animation="wave"
        variant="rectangular"
        width={'90%'}
        height={151}
      />
      <Skeleton
        id={'code-skeleton'}
        data-testid={'code-skeleton'}
        animation="wave"
        style={{ marginTop: theme.spacing(2) }}
        variant="rectangular"
        width={'90%'}
        height={93}
      />
    </>
  );
};
